<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.04406 17.5829C7.25396 18.2988 6.94141 19.2053 6.94141 19.9996C6.94141 20.5519 6.49369 20.9996 5.94141 20.9996C5.38912 20.9996 4.94141 20.5519 4.94141 19.9996C4.94141 18.6853 5.46068 17.2248 6.70118 16.1008C7.94416 14.9746 9.82058 14.2656 12.4002 14.2656C14.9775 14.2656 16.8532 14.9688 18.0965 16.0897C19.3382 17.2092 19.858 18.6661 19.858 19.9815C19.858 20.5338 19.4103 20.9815 18.858 20.9815C18.3057 20.9815 17.858 20.5338 17.858 19.9815C17.858 19.1873 17.546 18.2862 16.7573 17.5752C15.9703 16.8656 14.6171 16.2656 12.4002 16.2656C10.1847 16.2656 8.83169 16.8693 8.04406 17.5829Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4001 5C10.6748 5 9.27539 6.39914 9.27539 8.12567C9.27539 9.85216 10.6748 11.2513 12.4001 11.2513C14.1265 11.2513 15.5258 9.852 15.5258 8.12567C15.5258 6.39929 14.1265 5 12.4001 5ZM7.27539 8.12567C7.27539 5.29487 9.56996 3 12.4001 3C15.2311 3 17.5258 5.29471 17.5258 8.12567C17.5258 10.9566 15.2311 13.2513 12.4001 13.2513C9.56997 13.2513 7.27539 10.9564 7.27539 8.12567Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
